import { Component,ViewChild, ElementRef } from '@angular/core';
import { IonicPage, Platform, NavController, ActionSheetController,LoadingController, ToastController } from 'ionic-angular';
import { Camera } from '@ionic-native/camera';
import { Base64ToGallery } from '@ionic-native/base64-to-gallery';
import { MockupProvider } from '../../providers/mockup/mockup';
import { AndroidPermissions } from '@ionic-native/android-permissions';
import { LangPage } from '../lang/lang';
import { InfoPage } from '../info/info';

import { TranslateService } from '@ngx-translate/core';
import { PopoverController } from 'ionic-angular';

@IonicPage()
@Component({
  selector: 'page-editor',
  templateUrl: 'editor.html',
})
export class EditorPage {
  // picture : any = null;
  @ViewChild('file') fileInput: ElementRef;
  fileToUpload: File = null;
  picture : any = null;
  loading: any = null;
  canvas:any = {
    width : 1000,
    height : 1000
  };
  preview:any = null;
  canvas_ctx : any;
  icon:any = null;
  radius:any;
  mode = false;
  showButtons = true;
  radius_list:any = [
    {
      title:"SQUARE",
      radius:0
    },
    {
      title:"ROUNDR",
      radius:18
    },
    {
      title:"CIRCLE",
      radius:50
    },
  ];
  size:any = {
    width:1000,
    height:1000
  };
  i18n: string[] = [];
  edited : boolean = false;
  grid = false;

  constructor(
    private camera: Camera,
    private translate: TranslateService,
    private actionSheetCtrl: ActionSheetController,
    private toastCtrl: ToastController,
    private platform: Platform,
    private navCtrl: NavController,
    private base64ToGallery: Base64ToGallery,
    private androidPermissions: AndroidPermissions,
    private loadingCtrl: LoadingController,
    private mockupProvider: MockupProvider,
    private popoverCtrl: PopoverController
  ) {
    this.radius = this.radius_list[1].radius;
    // console.log("this.radius",this.radius);
    this.platform.ready().then(() => {
      this.refreshLang();
      if(this.platform.is('android')){
        console.log("platform android");
        this.androidPermissions.checkPermission(this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE).then(
          result => {
            // console.log('Has permission?',result.hasPermission);
            if(!result.hasPermission)
              this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE]);
          },
          err => {
            console.log('Err',err);
            this.androidPermissions.requestPermissions([this.androidPermissions.PERMISSION.WRITE_EXTERNAL_STORAGE]);
          }
        );
      }
    });

    this.translate.onLangChange.subscribe((event) => {
      setTimeout(() => {
        this.refreshLang();
      },400);
    });
  }

  setActive(radius){
    this.radius = radius;
  }
  refreshLang(){
    // console.log("refresh lang");
    this.translate
      .get([
        'PICTURE_ADDED_TO_GALLERY',
        'PICTURE_DOWNLOADED',
        'ERROR_SAVING_GALLERY',
        'EXPORT_IN_PROGRESS',
        'TITLE_ALERT_LEAVE',
        'MESSAGE_ALERT_LEAVE',
        'SAVE',
        'LEAVE_WITHOUT_SAVE',
        'SELECT_PICTURE',
        'OK',
        'YES',
        'NO',
        'CANCEL',
        'TITLE',
        'SUBTITLE',
        'DEMO_PICTURE',
        'LOAD_FROM_LIBRARY',
        'LOAD_FROM_COMPUTER',
        'USE_CAMERA'
      ])
      .subscribe(value => {
        this.i18n = value;
        // console.log("this.i18n",this.i18n);
      });
  }

  goToInfo(){
    this.navCtrl.push(InfoPage);
  }

  triggerFileInputClick() {
      this.fileInput.nativeElement.click();
  }

  onFileInputChange(files: FileList) {
      this.fileToUpload = files.item(0);

      if (this.fileInput.nativeElement.value != '')
      {
          // console.log('onFileInputChange', this.fileInput.nativeElement.value);
          // console.log('this.fileToUpload', this.fileToUpload);
          this.fileToBase64(this.fileToUpload);
          // this.upload();
      }
  }

  getImageDimensions(base64) {
    return new Promise ((resolved, rejected) => {
      var i = new Image()
      i.onload = function(){
        resolved({w: i.width, h: i.height})
      };
      i.src = "data:image/png;base64," + base64;
    })
  }

  fileToBase64(file) {
     let reader = new FileReader();
     reader.readAsDataURL(file);
     reader.onload = () => {
       // console.log(reader.result);
       let data = reader.result.replace('data:image/png;base64,', '');
       data = data.replace('data:image/jpeg;base64,', '');
       data = data.replace('data:image/jpg;base64,', '');
       data = data.replace('data:image/webp;base64,', '');
       data = data.replace('data:image/gif;base64,', '');
       // console.log("file",file);
       // console.log("reader",reader);
       this.getPicture(data)
       .then((picture) => {
         // console.log("fileToBase64 getPicture", picture);
         this.canvas.width = picture.size.width;
         this.canvas.height = picture.size.height;
         this.icon =  picture;
         this.updateCanvas();
       })
       .catch((err) => {
         console.error("fileToBase64 getPicture error",err);
       });
     };
     reader.onerror = (error) => {
       console.log('Error: ', error);
     };
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad EditorPage');
  }
  ionViewDidEnter() {
    this.canvas = document.getElementById('canvas');
    console.log("this.canvas",this.canvas);
    this.canvas_ctx = this.canvas.getContext("2d");
    this.canvas.width  = this.size.width;
    this.canvas.height  = this.size.height;
    this.updateCanvas();
  }

  updateCanvas(){
    // console.log("updateCanvas ",this.icon);
    if(this.icon != null)
      this.picture = this.loadImage(this.icon["contenu"]);
    else {
      this.picture = null;//this.loadImage('assets/imgs/default.png');
      this.draw();
    }
  }

  showPreview(){
    this.generatePreview();
    setTimeout(function(){
      // console.log(document.getElementById("preview_picture"));
      document.getElementById("preview_picture").click();
    },300)
  }
  loadImage(src){
    let img = new Image();
    // img.onload = this.draw();
    img.src = src;
    img.onload=()=>{
      this.draw();
    };

    return img;
  }


  generatePreview(){
    let dt = this.canvas.toDataURL('image/png');
    // console.log("generatePreview",dt.length);
    dt = dt.replace('data:image/png;base64,', '');
    this.getPicture(dt)
    .then((picture) => {
      // console.log("generatePreview getPicture", picture);
      this.preview =  picture;
    })
    .catch((err) => {
      console.error("generatePreview getPicture error",err);
    });
  }

  export(){
    this.generatePreview();
    setTimeout(() => {
      if(this.platform.is('cordova')) {

        this.presentLoading(this.i18n["EXPORT_IN_PROGRESS"]);
        // console.log("export : base64ToGallery");
        this.base64ToGallery.base64ToGallery(this.preview.contenu).then(
          (res) => {
            // console.log("export : base64ToGallery res");
            setTimeout(() => {
              this.hideLoading();
              this.presentToast(this.i18n["PICTURE_ADDED_TO_GALLERY"]);
              console.log('Saved image to gallery ', res)
            },1000);
          },
          (err) => {
            console.log("export : base64ToGallery res");
            setTimeout(() => {
              this.hideLoading();
              this.presentToast(this.i18n["ERROR_SAVING_GALLERY"] + ' : ' + err);
              console.log('Error saving image to gallery ', err)
            },1000);
          }
        );
      }
      else
      {
        this.exportWeb();
      }
    },300);
  }

  exportWeb(){
    this.presentLoading(this.i18n["EXPORT_IN_PROGRESS"]);
    setTimeout(() => {
      this.hideLoading();
      this.presentToast(this.i18n["PICTURE_DOWNLOADED"]);
      let dt = this.preview.contenu;
      /* Change MIME type to trick the browser to downlaod the file instead of displaying it */
      dt = dt.replace(/^data:image\/[^;]*/, 'data:application/octet-stream');

      /* In addition to <a>'s "download" attribute, you can define HTTP-style headers */
      dt = dt.replace(/^data:application\/octet-stream/, 'data:application/octet-stream;headers=Content-Disposition%3A%20attachment%3B%20filename=Canvas.png');

      let a = document.createElement('a');
      a.href=dt;
      a.download = "roundr.png";
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    },1000);
  }

  setMode(val){
    this.mode = val;
    this.draw();
  }
  changeMode(){
    // console.log("changeMode");
    // this.mode = !this.mode;
    this.draw();
  }
  draw(){

    // console.log("draw");
  	this.canvas_ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);

    // Draw image rounded
    this.canvas_ctx.save();
    if(!this.mode)
      this.roundedRectImage(0,0,this.canvas.width,this.canvas.height,((this.radius/100) * this.canvas.width));
    else
      this.roundedCustomImage(0,0,this.canvas.width,this.canvas.height,((this.radius/100) * this.canvas.width));

    this.canvas_ctx.clip();

    if(this.picture == null){
      this.canvas_ctx.fillStyle = "#393939";
      this.canvas_ctx.globalAlpha = 1;
    	this.canvas_ctx.fillRect(0, 0, this.canvas.width, this.canvas.height);
    }
    else
      this.canvas_ctx.drawImage(this.picture,0,0,this.canvas.width,this.canvas.height);

    this.canvas_ctx.restore();

  }



  roundedCustomImage(x, y, w, h, r) {
    this.canvas_ctx.beginPath();
    this.canvas_ctx.moveTo(x + r, y);
    this.canvas_ctx.lineTo(x + w - r, y);
    this.canvas_ctx.quadraticCurveTo(x + w, y, x + w, y + r);
    this.canvas_ctx.lineTo(x + w, y + h - r);
    this.canvas_ctx.quadraticCurveTo(x + w, y + h, x + w - r, y + h);
    this.canvas_ctx.lineTo(x + r, y + h);
    this.canvas_ctx.quadraticCurveTo(x, y + h, x, y + h - r);
    this.canvas_ctx.lineTo(x, y + r);
    this.canvas_ctx.quadraticCurveTo(x, y, x + r, y);
    this.canvas_ctx.closePath();
    return;
  }


  roundedRectImage(x, y, w, h, r) {
    if (w < 2 * r) r = w / 2;
    if (h < 2 * r) r = h / 2;
    this.canvas_ctx.beginPath();
    this.canvas_ctx.moveTo(x+r, y);
    this.canvas_ctx.arcTo(x+w, y,   x+w, y+h, r);
    this.canvas_ctx.arcTo(x+w, y+h, x,   y+h, r);
    this.canvas_ctx.arcTo(x,   y+h, x,   y,   r);
    this.canvas_ctx.arcTo(x,   y,   x+w, y,   r);
    this.canvas_ctx.closePath();
    return;
  }

  setRadius(){
    // console.log("setRadius",this.radius);
    this.edited = true;
    this.draw();
  }

  toogleGrid(){
    this.edited = true;
    this.grid = !this.grid;
    this.draw();
  }


  presentPopover(myEvent) {
    let popover = this.popoverCtrl.create(LangPage);
    popover.present({
      ev: myEvent
    });
  }

  presentActionSheet() {
    let button_library = {
      text: this.i18n["LOAD_FROM_LIBRARY"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.PHOTOLIBRARY);
      }
    };
    let button_camera = {
      text: this.i18n["USE_CAMERA"],
      handler: () => {
        this.takePicture(this.camera.PictureSourceType.CAMERA);
      }
    }
    let button_import_web= {
      text: this.i18n["LOAD_FROM_COMPUTER"],
      handler: () => {
        this.triggerFileInputClick();
      }
    }
    let button_cancel = {
      text: this.i18n["CANCEL"],
      role: 'cancel'
    }
    let button_demo = {
      text: this.i18n["DEMO_PICTURE"],
      handler: () => {
        this.takeDemoPicture();
      }
    };
    let buttons = [button_demo,button_import_web,button_cancel];
    if(this.platform.is('cordova'))
      buttons = [button_demo,button_library,button_camera,button_cancel];

    let titletext = this.i18n["SELECT_PICTURE"];
    // console.log("titletext",titletext);
    let actionSheet = this.actionSheetCtrl.create({
      title: titletext,
      buttons: buttons
    });
    actionSheet.present();
  }


  takeDemoPicture(){
    this.mockupProvider
      .getImageDemo()
      .then(dataUrl => {
        // console.log("takeDemoPicture success");
        return this.getPicture(dataUrl);
      })
      .then(picture => {
        this.canvas.width = picture.size.width;
        this.canvas.height = picture.size.height;
        this.icon =  picture;
        this.updateCanvas();
        this.edited = true;
      })
      .catch(err => {
        console.error("error loading takeDemoPicture",err);
      });
  }
  async takePicture(sourceType){

    var options = {
      quality: 100,
      sourceType: sourceType,
      targetWidth:1024,
      targetHeight:1024,
      destinationType: this.camera.DestinationType.DATA_URL,
      saveToPhotoAlbum: false,
      correctOrientation: true
    };

    this.camera.getPicture(options).then((dataUrl) => {
      // console.log("takePicture",dataUrl);
      this.getPicture(dataUrl)
      .then(picture => {
        console.log("picture",picture);
        console.log("picture width",picture.size.width);
        console.log("picture height",picture.size.height);
        this.canvas.width = picture.size.width;
        this.canvas.height = picture.size.height;
        this.icon =  picture;
        this.updateCanvas();
        this.edited = true;
      })
      .catch(err => {
        console.error("error loading takeDemoPicture",err);
      });
    }, (err) => {
      this.presentToast('Error while selecting image.');
    });
  }

  async getPicture(dataUrl){

    let size = await this.getImageDimensions(dataUrl);
    // console.log("size",size);
    let picture_name = new Date().getTime();
    let picture = {
      title: picture_name,
      contenu: "data:image/png;base64," + dataUrl,
      type: 'image/jpeg',
      size: {
        width: size["w"],
        height: size["h"]
      }
    };
    return picture;
  }



  presentLoading(content = 'Please wait...') {
    this.loading = this.loadingCtrl.create({
      content: content
    });

    this.loading.present();
  }

  hideLoading(){
    this.loading.dismiss();
  }

  presentToast(message, duration = 3000) {
    // console.log('presentToast', message)
    let toast = this.toastCtrl.create({
      message: message,
      duration: duration,
      position: 'middle',
      cssClass: 'custom_toast'
    });

    toast.onDidDismiss(() => {
      console.log('Dismissed toast');
    });

    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/editor/editor.ts